import React from 'react';

const ProcessingIndicator = ({ language }) => {
  return (
    <div className="processing-indicator">
      <div className="spinner"></div>
      <p>{language === 'KR' ? '이미지 처리 중...' : 'Processing image...'}</p>
    </div>
  );
};

export default ProcessingIndicator;